/**
 * Get the current user
 * @param {object} state - The vuex state object
 * @return {object[]} A object of the current user
 */
export const getCurrentUser = (state) => {
  return state.currentUser
};

/**
 * check if user is logged in
 * @param {object} state - The vuex state object
 * @return {Boolean} return boolean
 */
export const isLoggedIn = (state) => {
  return !!state.currentUser
};


/**
 * Get the token from the state object
 * @param {object} state - The vuex state object
 * @return {object} return token object
 */
export const getPasswordToken = (state) => {
  return state.passwordToken
};

